import addressTranslations from "./addressTranslations";
import organizationEmailTranslations from "./organizationEmailTranslations";
import organizationTranslation from "./organizationTranslation";

export const opponentLawFirmTranslations = {
  organization: {
    name: {
      label: "Kanzlei",
    },
    mainEmail: organizationEmailTranslations,
    telephone: {
      label: "Telefonnummer",
    },
    fax: {
      label: "Faxnummer",
    },
    beaSafeId: {
      label: "beA-Adresse",
    },
    address: addressTranslations,
  },
  organizationEmail: organizationEmailTranslations,
};
